<template>
  <div class="header-wrapper">
    <div class="header-inner">
      <div class="logo" @click="goHome">
        <img src="../assets/PBSDLogo-min.png" alt class="logo-img">
        <span>广州贯微建筑科技</span>
      </div>
      <ul class="nav">
        <li
          v-for="(item, i) in navs"
          :key="i"
          @click="goId(item.id)"
          :class="{'active':currentId === item.id}"
        >{{item.name}}</li>
      </ul>
      <div class="login">
        <template v-if="hasToken">
          <img src="../assets/avatar.png" alt class="avatar" @click="myCenter">
          <p class="logout-btn" @click="logout">退出</p>
        </template>
        <template v-else>
          <p @click="signIn">登录</p>
          <p @click="signUp" class="sign-up-btn">注册</p>
        </template>
      </div>
      <div class="menu">
        <div class="menu-icon" @click="toggleMenu">
          <img v-if="isShowMenu" src="../assets/close.png" alt>
          <img v-else src="../assets/menu.png" alt>
        </div>
        <ul class="menu-ul" v-show="isShowMenu">
          <li v-for="(item, i) in navs" :key="i" @click="goId(item.id)">{{item.name}}</li>
         
          <template v-if="hasToken">
            <li @click="myCenter">个人中心</li>
            <li @click="logout">退出登录</li>
          </template>
          <template v-else>
            <li @click="signIn" class="divided">登录</li>
            <li @click="signUp">注册</li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { navs } from '@/config/types.config'
// import { getToken } from '@/util/auth'

export default {
  name: 'HeaderBar',
  props: {  
    //“增值服务购买”预留
    //<button class="pr-btn dark-btn" @click="pay">增值服务购买</button>
    // <li @click="pay">增值服务购买</li>
   },
  data() {
    return {
      navs,
      isShowMenu: false,
      currentId: ''
    }
  },
  watch: {},
  methods: {
    closeNav() {
      this.isShowMenu = false
    },
    goId(id) {
      this.currentId = id
      this.$router.push({ path: `/#${id}` })
      this.closeNav()
    },
    goHome() {
      this.$router.push({ path: '/' })
      this.closeNav()
    },
    myCenter() {
      this.$router.push({ path: '/my-center' })
      this.closeNav()
    },
    pay() {
      this.$router.push({ path: '/pay/' })
      this.closeNav()
    },
    signIn() {
      this.$router.push({ path: '/login' })
      this.closeNav()
    },
    signUp() {
      this.$router.push({ path: '/login/sign-up' })
      this.closeNav()
    },
    toggleMenu() {
      this.isShowMenu = !this.isShowMenu
    },
    logout() {
      this.$store.dispatch('FedLogOut').then(() => {
        this.$router.push({ path: '/login' })
      })
    }
  },
  computed: {
    hasToken() {
      return !!this.$store.getters.token
    }
  }
}
</script>
<style lang="less" scoped>
.header-wrapper {
  width: 100%;
  font-family: "Microsoft YaHei";
  background: #fff;
  .header-inner {
    max-width: 1024px;
    margin: 0 auto;
    font-size: 16px;
    padding: 0 19px;
    height: 63px;
    color: #000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      line-height: 20px;
      height: 20px;

      font-size: 20px;
      font-weight: 600;
      color: rgba(44, 90, 200, 1);

      display: flex;
      align-items: center;
      cursor: pointer;
      .logo-img {
        width: 30px;
        margin-right: 10px;
      }
    }
  }
  .nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    li {
      cursor: pointer;
      color: #000;
      display: inline-block;
      height: 100%;
      line-height: 63px;
      padding: 0 20px;
      &:first-child {
        font-weight: bold;
      }
      &:hover {
        color: #ffffff;
        background-color: rgba(44, 90, 200, 1);
      }
      // &:active {
      //   color: #ffffff;
      //   background-color: rgba(44, 90, 200, 0.5);
      // }
      // &.active {
      //   color: rgba(44, 90, 200, 1);
      // }
    }
  }
  .login {
    display: flex;
    justify-content: space-between;
    align-items: center;
    p {
      margin-right: 15px;
      //margin-right: 5px;
      cursor: pointer;
      &.sign-up-btn,
      &.logout-btn {
        margin-right: 15px;
      }
      &:hover {
        color: rgba(44, 90, 200, 1);
      }
    }
    .avatar {
      width: 31px;
      margin-right: 15px;
      cursor: pointer;
    }
  }
  .menu {
    display: none;
    position: absolute;
    z-index: 100;
    top: 20px;
    right: 20px;
    .menu-icon {
      img {
        width: 25px;
      }
    }
    .menu-ul {
      background-color: #ffffff;
      z-index: 2;
      border-radius: 5px 0 5px 5px;
      color: #000;
      position: absolute;
      // top: 25px;
      // right: 0;
      width: 120px;
      box-shadow: -1px -1px 4px 1px rgba(44, 90, 200, 0.2);
      top: 34px;
      right: -5px;

      li {
        padding: 10px;
        &.divided {
          border-top: 1px solid #eeeeee;
        }
        &:hover {
          background: rgba(44, 90, 200, 0.1);
        }
      }
    }
  }
}
@media screen and (max-width: 990px) {
  .header-wrapper {
    .nav,
    .login {
      display: none;
    }
    .menu {
      display: block;
    }
  }
}
</style>
